var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "url(#paint0_linear_2271_4470)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_4470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 16.6445C18.9772 16.6445 14.5 21.1217 14.5 26.6445C14.5 28.626 15.077 30.4748 16.0725 32.0297C16.2038 32.2348 16.4305 32.3588 16.674 32.3588H32.326C32.5694 32.3588 32.7963 32.2348 32.9276 32.0297C33.923 30.4748 34.5 28.626 34.5 26.6445C34.5 21.1217 30.0229 16.6445 24.5 16.6445ZM23.8219 29.5017L27.1527 23.9504C27.4571 23.443 28.1153 23.2785 28.6227 23.5829C29.1301 23.8874 29.2946 24.5455 28.9901 25.0529L26.3209 29.5017H23.8219Z",
    fill: "url(#paint1_linear_2271_4470)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_4470",
    x1: 49,
    y1: 49,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AC693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DFAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_4470",
    x1: 24.5,
    y1: 16.6445,
    x2: 24.5,
    y2: 32.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_4470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14.5 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMeter);
export default __webpack_public_path__ + "static/media/green-meter.3b8272a65fee04b09fc7da9d61915a07.svg";
export { ForwardRef as ReactComponent };